import React, { use, useRef } from "react";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";

import { Player } from "@lottiefiles/react-lottie-player";

import { useState } from "react";
import { useSnackbar } from "notistack";
import Modal1 from "../modals/Modal1";

import { useAppContext } from "../config/AppContext";
import { useEffect } from "react";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import TextField2T from "../textfields/TextField2T";
import {
  loginWithEmailAndPassword,
  loginWithGoogle,
} from "../auth/FirebaseAuth"; // Updated import
import Space from "../layout/Space";
import { User } from "../types/basicTypes";
import { GridBackgroundPage } from "../assets/GridBackgroundPage";
import WhiteRoundedButton from "../buttons/WhiteRoundedButton";
import { useSearchParams } from "react-router-dom";
import Icon1 from "../assets/icons/Icon";
import SearchBar1 from "../textfields/SearchBar1";
import SearchBarFolders from "../textfields/SearchBarFolders";
import TFGPT1 from "../textfields/TFGPT1";
import {
  getDocDataById,
  getRefFromId,
  queryCollection,
} from "../models/DataFunctions";
import { Timestamp, updateDoc } from "firebase/firestore";
import updateDocApi from "../api/database/updateDocApi";
import SmallSpinner from "../loading/SmallSpinner";
import { SubscribeButton } from "./SubscribeButton";

interface LoginProps {
  userData: User | null;
  navigateWorkspace: (path: string) => void;
  handleLogout: any;
}

export interface FaqItem {
  id: string;
  url: string;
  title: string;
  content: string;
  publication_date: string;
  tags: string[];
  views: number;
}

function Faq({ userData, navigateWorkspace, handleLogout }: LoginProps) {
  const [searchParams] = useSearchParams();
  const [active_tab, setActiveTab] = useState<string>("general");

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [faq_pages, setFaqPages] = useState<FaqItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [search_value, setSearchValue] = useState("");

  const mainScrollRef = useRef<HTMLDivElement>(null);

  const handleFetchData = async () => {
    setLoading(true);
    let faq_pages = (await queryCollection(
      "faq_pages",
      []
    )) as any[] as FaqItem[];
    setFaqPages(faq_pages);
    setLoading(false);
  };

  const addView = async (id: string) => {
    console.log("add view to ", id);
    let faq_page = await getDocDataById("faq_pages", id);
    console.log(faq_page);
    let ref = getRefFromId("faq_pages", id);
    if (!ref) return;
    await updateDoc(ref, "views", (faq_page?.views || 0) + 1);
  };

  const filtered_faq_pages = faq_pages.filter((item) =>
    (item.title.toLowerCase() + item.content.toLowerCase()).includes(
      search_value.toLowerCase()
    )
  );

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <div
      ref={mainScrollRef}
      className="h-screen overflow-auto bg-neutral-200 select-none"
    >
      <div className="h-fit flex z-10 pb-60 flex-row w-full justify-center">
        <div className="w-full h-fit  flex relative justify-center items-end">
          <div className=" w-full p-6 flex-col flex gap-4 h-fit md:items-center">
            <div className="font-extrabold text-hx4 md:text-hx6 text-neutral-600 mb-4">
              FAQ RE2020
            </div>
            <div className="bg-white  rounded-full max-w-c500 p-3 w-full flex flex-row gap-2 items-center  pr-4">
              <input
                placeholder="Quelle surface doit être prise en compte dans le calcul ..."
                className="text-h2 w-full   px-4 outline-transparent"
                value={search_value}
                onChange={(e) => {
                  setActiveTab("general");
                  setSearchValue(e.target.value);
                }}
              ></input>
              <Icon1 icon_name="search" fill="grey" size={20}></Icon1>
            </div>

            {loading ? (
              <SmallSpinner></SmallSpinner>
            ) : (
              <>
                {(active_tab === "opened" || active_tab === "general") &&
                  search_value.length === 0 && (
                    <div
                      className="flex flex-col gap-2 items-start mt-8  w-full"
                      style={{ maxWidth: "820px" }}
                    >
                      <div className="text-h2 text-neutral-400 font-semibold mb-2"></div>{" "}
                      <TitleBlock
                        title="Consulté récemment"
                        onClick={() =>
                          active_tab === "opened"
                            ? setActiveTab("general")
                            : setActiveTab("opened")
                        }
                        active={active_tab === "opened"}
                      ></TitleBlock>
                      <div className="flex flex-wrap gap-4 justify-start">
                        {filtered_faq_pages
                          .filter((item) =>
                            (appState.last_faq_opened || []).includes(item.id)
                          )
                          .sort((a, b) => {
                            // Sort by order in last_faq_opened
                            return (
                              (appState.last_faq_opened || []).indexOf(b.id) -
                              (appState.last_faq_opened || []).indexOf(a.id)
                            );
                          })
                          .slice(0, active_tab === "opened" ? 20 : 2)
                          .map((item, index) => (
                            <div key={index}>
                              <FAQBlock
                                content={item.content}
                                title={item.title}
                                tag={item.tags[0]}
                                publication_date={item.publication_date}
                                onClick={() => {
                                  navigateWorkspace("/faq/" + item.id);
                                  addView(item.id);
                                  setAppState((prevState: any) => ({
                                    ...prevState,
                                    last_faq_opened: [
                                      ...(prevState.last_faq_opened || []),
                                      item.id,
                                    ],
                                  }));
                                }}
                                views={item.views}
                                search_value={search_value}
                              ></FAQBlock>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                {(active_tab === "recent" || active_tab === "general") &&
                  search_value.length === 0 && (
                    <div
                      className="flex flex-col gap-2 items-start mt-8 w-full"
                      style={{ maxWidth: "820px" }}
                    >
                      <div className="text-h2 text-neutral-400 font-semibold mb-2"></div>{" "}
                      <TitleBlock
                        title="Les plus récents"
                        onClick={() =>
                          active_tab === "recent"
                            ? setActiveTab("general")
                            : setActiveTab("recent")
                        }
                        active={active_tab === "recent"}
                      ></TitleBlock>
                      <div className="flex flex-wrap gap-4 justify-start">
                        {filtered_faq_pages
                          .sort(
                            (a, b) =>
                              // publication_date is dd/mm/yyyy
                              new Date(
                                b.publication_date
                                  ?.split("/")
                                  .reverse()
                                  .join("-")
                              ).getTime() -
                              new Date(
                                a.publication_date
                                  ?.split("/")
                                  .reverse()
                                  .join("-")
                              ).getTime()
                          )
                          .slice(0, active_tab === "recent" ? 20 : 2)
                          .map((item, index) => (
                            <div key={index}>
                              <FAQBlock
                                content={item.content}
                                title={item.title}
                                tag={item.tags[0]}
                                publication_date={item.publication_date}
                                onClick={() => {
                                  setAppState((prevState: any) => ({
                                    ...prevState,
                                    last_faq_opened: [
                                      ...(prevState.last_faq_opened || []),
                                      item.id,
                                    ],
                                  }));
                                  addView(item.id);
                                  navigateWorkspace("/faq/" + item.id);
                                }}
                                views={item.views}
                                search_value={search_value}
                              ></FAQBlock>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                {(active_tab === "popular" || active_tab === "general") &&
                  search_value.length === 0 && (
                    <div
                      className="flex flex-col gap-2 items-start mt-8  w-full"
                      style={{ maxWidth: "820px" }}
                    >
                      <TitleBlock
                        onClick={() =>
                          active_tab === "popular"
                            ? setActiveTab("general")
                            : setActiveTab("popular")
                        }
                        title="Les plus consultés"
                        active={active_tab === "popular"}
                      ></TitleBlock>
                      <div className="flex flex-wrap gap-4 justify-start">
                        {filtered_faq_pages
                          .sort(
                            // Sort by views
                            (a, b) => (b.views || 0) - (a.views || 0)
                          )
                          .slice(0, active_tab === "popular" ? 20 : 2)
                          .map((item, index) => (
                            <div key={"popular" + item.id}>
                              <FAQBlock
                                content={item.content}
                                title={item.title}
                                onClick={() => {
                                  setAppState((prevState: any) => ({
                                    ...prevState,
                                    last_faq_opened: [
                                      ...(prevState.last_faq_opened || []),
                                      item.id,
                                    ],
                                  }));
                                  addView(item.id);
                                  navigateWorkspace("/faq/" + item.id);
                                }}
                                tag={item.tags[0]}
                                publication_date={item.publication_date}
                                views={item.views}
                                search_value={search_value}
                              ></FAQBlock>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                {active_tab === "general" && (
                  <div
                    className="flex flex-col gap-2 items-start mt-8 w-full   "
                    style={{ maxWidth: "820px" }}
                  >
                    <TitleBlock title="Tous les articles"></TitleBlock>
                    <div className="flex flex-wrap gap-4 justify-start ">
                      {filtered_faq_pages
                        .sort((a, b) => (a.title > b.title ? 1 : -1))
                        .map((item, index) => (
                          <div key={index}>
                            <FAQBlock
                              content={item.content}
                              title={item.title}
                              onClick={() => {
                                setAppState((prevState: any) => ({
                                  ...prevState,
                                  last_faq_opened: [
                                    ...(prevState.last_faq_opened || []),
                                    item.id,
                                  ],
                                }));
                                addView(item.id);
                                navigateWorkspace("/faq/" + item.id);
                              }}
                              tag={item.tags[0]}
                              publication_date={item.publication_date}
                              views={item.views}
                              search_value={search_value}
                            ></FAQBlock>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <SubscribeButton />

          <div
            onClick={() => {
              console.log("scroll to top");
              window.scrollTo({ top: 0, behavior: "smooth" });
              mainScrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="fixed bg-wshadow_50 md:hidden rounded-full p-3 border-1 border-white bottom-40 right-8 z-20"
          >
            <Icon1 icon_name="up" size={22}></Icon1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;

interface FAQBlockProps {
  content: string;
  title: string;
  tag?: string;
  publication_date?: string;
  onClick?: () => void;
  views?: number;
  search_value?: string;
}

const FAQBlock = ({
  content,
  title,
  tag,
  views = 0,
  publication_date = "22/05/2024",
  onClick,
  search_value = "",
}: FAQBlockProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-wshadow_50 backdrop-blur-sm border-1 cursor-pointer hover:bg-wshadow_90 duration-300 transition-all border-white rounded-2xl p-4  flex w-full max-w-c400 flex-col gap-2   pr-4"
    >
      <div className="text-h3 font-medium text-neutral-600 ">{title}</div>
      {search_value?.length > 0 && (
        <div className="text-h3 font-medium text-neutral-600 ">
          {HighlightedText(content, search_value)}
        </div>
      )}

      <div className="flex flex-row justify-between items-end">
        <div className="text-h4 text-neutral-400 mt-2">
          Publié le {publication_date}{" "}
          {<span className="text-neutral-300"> - {views} vues</span>}
        </div>
        <div
          className={`text-h4 font-medium  py-1 px-2 mt-2 rounded-lg 0 w-fit border-1
      ${colorFromTag(tag || "default")}
      
      `}
        >
          {tag}
        </div>
      </div>
    </div>
  );
};

const HighlightedText = (text: string, highlight: string) => {
  if (!highlight) return text;
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={i} className="bg-purple-200">
            {part}
          </span>
        ) : (
          <span className="text-neutral-400" key={i}>
            {part}
          </span>
        )
      )}
    </>
  );
};

export const colorFromTag = (tag: string) => {
  switch (tag) {
    case "chauffage":
      return "bg-red-100 border-red-300 text-red-400";
    case "ventailtion":
      return "bg-blue-100 border-blue-300 text-blue-400";
    case "ECS":
      return "bg-yellow-100 border-yellow-300 text-yellow-400";
    case "reglementation":
      return "bg-green-100 border-green-300 text-green-400";
    case "ventilation":
      return "bg-purple-100 border-purple-300 text-purple-400";
    case "energie":
      return "bg-pink-100 border-pink-300 text-pink-400";
    default:
      return "bg-blue-100 border-blue-300 text-blue-400";
  }
};

const TitleBlock = ({
  title,
  onClick,
  active,
}: {
  title: string;
  onClick?: () => void;
  active?: boolean;
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        ${
          active
            ? "bg-wshadow_50 border-1 border-white p-2 rounded-md"
            : "text-neutral-400"
        }
        text-h2 flex cursor-pointer hover:text-neutral-500 items-center flex-row gap-2 text-neutral-400 font-semibold mb-2`}
    >
      {title}
      {!active ? (
        <Icon1 icon_name="plus" fill="grey" size={14}></Icon1>
      ) : (
        <Icon1 icon_name="close" fill="grey" size={14}></Icon1>
      )}
    </div>
  );
};
